import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { RouterPathName } from "@/enums/router-path-name.enum";
import { jwtGuard } from "@/guards/jwt.guard";
import { falconGuard } from "@/guards/falcon.guard";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: {
      name: RouterPathName.Authenticate
    }
  },
  {
    path: "/authenticate",
    name: RouterPathName.Authenticate,
    beforeEnter: jwtGuard,
    component: () =>
      import(
        /* webpackChunkName: "authenticate" */ "../views/AuthenticationPage.vue"
      )
  },
  {
    path: "/app",
    name: RouterPathName.AppMain,
    beforeEnter: jwtGuard,
    component: () =>
      import(/* webpackChunkName: "app-main" */ "../views/AppPage.vue"),
    children: [
      {
        path: "falcon",
        beforeEnter: falconGuard,
        component: () =>
          import(
            /* webpackChunkName: "falcon-view" */ "../views/falcon/FalconView.vue"
          ),
        children: [
          { path: "", redirect: { name: RouterPathName.FalconPaymentsView } },
          {
            path: "payments",
            name: RouterPathName.FalconPaymentsView,
            component: () =>
              import(
                /* webpackChunkName: "falcon-payments-view" */ "../views/falcon/PaymentsView.vue"
              )
          },
          {
            path: "documents",
            name: RouterPathName.FalconDocumentsView,
            component: () =>
              import(
                /* webpackChunkName: "falcon-documents-view" */ "../views/falcon/DocumentsView.vue"
              ),
            children: [
              {
                path: ":documentId/details",
                name: RouterPathName.FalconDocumentsWithDocumentDetails,
                components: {
                  documentsTableAside: () =>
                    import(
                      /* webpackChunkName: "falcon-documents-table-aside" */ "../components/falcon/documents/DocumentDetails.vue"
                    )
                }
              }
            ]
          },
          {
            path: "complaints",
            name: RouterPathName.FalconComplaintsView,
            component: () =>
              import(
                /* webpackChunkName: "falcon-complaints-view" */ "../views/falcon/ComplaintsView.vue"
              )
          },
          {
            path: "complaints/create/:documentId/:itemId/:productId/step",
            component: () =>
              import(
                /* webpackChunkName: "falcon-complaint-form-view" */ "../views/falcon/ComplaintFormView.vue"
              ),
            children: [
              {
                path: "",
                redirect: { name: RouterPathName.FalconComplaintFirstStepForm }
              },
              {
                path: "details",
                name: RouterPathName.FalconComplaintFirstStepForm,
                component: () =>
                  import(
                    /* webpackChunkName: "falcon-complaint-first-step-form-view" */ "../components/falcon/complaints/ComplaintCreationFirstStepForm.vue"
                  )
              },
              {
                path: "vehicle",
                name: RouterPathName.FalconComplaintSecondStepForm,
                component: () =>
                  import(
                    /* webpackChunkName: "falcon-complaint-second-step-form-view" */ "../components/falcon/complaints/ComplaintCreationSecondStepForm.vue"
                  )
              },
              {
                path: "fault-description",
                name: RouterPathName.FalconComplaintThirdStepForm,
                component: () =>
                  import(
                    /* webpackChunkName: "falcon-complaint-third-step-form-view" */ "../components/falcon/complaints/ComplaintCreationThirdStepForm.vue"
                  )
              },
              {
                path: "summary",
                name: RouterPathName.FalconComplaintSummary,
                component: () =>
                  import(
                    /* webpackChunkName: "falcon-complaint-summary-view" */ "../components/falcon/complaints/ComplaintCreationSummary.vue"
                  )
              }
            ]
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base:
    process.env.NODE_ENV === "production"
      ? "/" + process.env.VUE_APP_PRODUCTION_PUBLIC_PATH + "/"
      : process.env.BASE_URL,
  routes
});

export default router;
